import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import en from "./lang/en.js";

const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "en",
  messages: {
    en
  }
});

export default i18n;
